module.exports = __webpack_public_path__ + "img/icon-hat.68b9f122.svg";